import { AppService, APP_MODE } from 'src/app/app.service';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/api.service';
import { UnitOfWorkOfflineDao } from '../../daos/unitofwork-offline.dao';
import { LogVariableEnvironnementUserService } from './log-variable-environnement-user.service'
import { LogVariableEnvironnementUserOnlineService } from './log-variable-environnement-user-online.service'
import { LogVariableEnvironnementUserOfflineService } from './log-variable-environnement-user-offline.service'

const LogVariableEnvironnementUserServiceFactory = (appService: AppService, httpClient: HttpClient, apiService: ApiService, unitOfWork: UnitOfWorkOfflineDao) =>
    appService.AppMode == APP_MODE.ONLINE_MODE ? 
    new LogVariableEnvironnementUserOnlineService(httpClient, apiService) : new LogVariableEnvironnementUserOfflineService(unitOfWork);

export const LogVariableEnvironnementUserServiceProvider = { 
    provide: LogVariableEnvironnementUserService,
    useFactory: LogVariableEnvironnementUserServiceFactory,
    deps: [AppService, HttpClient, ApiService, UnitOfWorkOfflineDao]
};